module.exports = __webpack_public_path__ + "static/carusel-popup-3931bed485e4ece506424b75700b9731.webp";